module.exports = __webpack_public_path__ + "static/media/checkout.f36e4d38.svg";